var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g({staticClass:"ph-panel",class:(typeof _vm.props.variant === 'string'
      ? [_vm.props.variant]
      : _vm.props.variant
    ).map(function (el) { return ("ph-panel--" + el); }).concat( [_vm.data.staticClass],
    [_vm.data.class] )},Object.assign({}, _vm.data.on,
    _vm.data.nativeOn)),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }